import common from "../../utill/Common";

class DbModuleService {
  add = async (
    token,
    package_id,
    user_type,
    domain_name,
    pan_number,
    name,
    shop_name,
    mobile,
    email,
    pincode,
    state,
    city,
    district,
    address
  ) => {
    const url = common.baseUrl + "user/db_module/add_user";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        package_id,
        user_type,
        domain_name,
        pan_number,
        name,
        shop_name,
        mobile,
        email,
        pincode,
        state,
        city,
        district,
        address,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  list = async (
    token,
    kyc_status,
    status,
    user_type,
    state,
    id,
    user_id,
    search_text,
    size,
    page
  ) => {
    const url = common.baseUrl + "user/db_module/fetch_users";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        kyc_status,
        status,
        user_type,
        state,
        id,
        user_id,
        search_text,
        size,
        page,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
  updatePackage = async (token, user_id, package_id) => {
    const url = common.baseUrl + "user/db_module/update_package";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        user_id,
        package_id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchByUserId = async (token, user_id) => {
    const url = common.baseUrl + "user/db_module/fetch_by_user_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        user_id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchById = async (token, id) => {
    const url = common.baseUrl + "user/db_module/fetch_by_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateProfile = async (
    token,
    user_id,
    user_type,
    domain_name,
    package_id,
    pan_number,
    name,
    dob,
    gender,
    mobile,
    email,
    pincode,
    state,
    city,
    district,
    address,
    wallet_hold,
    developer_access,
    status,
    kyc_status
  ) => {
    const url = common.baseUrl + "user/db_module/update_profile";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        token,
        user_id,
        user_type,
        domain_name,
        package_id,
        pan_number,
        name,
        dob,
        gender,
        mobile,
        email,
        pincode,
        state,
        city,
        district,
        address,
        wallet_hold,
        developer_access,
        status,
        kyc_status,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  resetLoginDetails = async (token, user_id, password, pin) => {
    const url = common.baseUrl + "user/db_module/reset_login_details";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ user_id, password, pin }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  changeStatus = async (token, id) => {
    const url = common.baseUrl + "user/db_module/change_status";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  balanceTransfer = async (token, user_id, amount) => {
    const url = common.baseUrl + "user/db_module/balance_transfer";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        user_id,
        amount,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  getNameFromUserId = async (token, user_id) => {
    const url = common.baseUrl + "user/db_module/get_name_from_user_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        token,
        user_id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  adminLogin = async (token) => {
    const url = common.baseUrl + "user/db_module/admin_login";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new DbModuleService();
